// src/modules/app-views/account/pages/Subscription/modals/VoipGotoAuthModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const GotoAuthStepContent = () => {
  return (
    <Alert
      title={translateX('goto_auth_title')}
      description={translateX('goto_auth_description')}
      type="info"
      showIcon
    />
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const gotoAuthStep = () => ({
  stepTitle: 'goto_voip_config',
  stepTooltip: 'goto_auth_title',
  content: () => <GotoAuthStepContent />,
  validationFields: [],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default gotoAuthStep;
